<template>
  <div class="flex flex-col">
    <div class="flex border-b border-gray-200 mb-4">
      <label
        :class="['tab-label', activeTab === 'form' ? 'tab-active' : 'tab-inactive']"
        @click="activeTab = 'form'"
      >
        <i class="fa fa-file-alt mr-2"></i>
       
        <span v-if="vtask && vtask.applicationType==='AFFILIATION'"> Registry File ({{ vtask.interimErn }})</span>
        <span v-else-if="vtask && vtask.applicationType==='FORCED_REGISTRATION'"> Forced Registration Details ({{ vtask.interimErn || 'N/A' }})</span>
        <span v-else>  Entity Information</span>
      </label>
      <label
        :class="['tab-label', activeTab === 'attachments' ? 'tab-active' : 'tab-inactive']"
        @click="activeTab = 'attachments'"
      >
        <i class="fa fa-paperclip mr-2"></i>
        Attachments
      </label>
      <label
        v-if="vtask && vtask.applicationType !== 'FORCED_REGISTRATION'"
        :class="['tab-label', activeTab === 'messages' ? 'tab-active' : 'tab-inactive']"
        @click="activeTab = 'messages'"
      >
        <i class="fa fa-comments mr-2"></i>
        Messages
      </label>
    </div>

    <div v-show="activeTab === 'form'">
      <div v-if="vtask && vtask.applicationType==='AFFILIATION'" >
                <RegistryFormDataViewer 
                  v-if="viewerFormData"
                  :form-data="viewerFormData" 
                  :value-data="viewerValueData" 
                  :affiliations="affiliations"
                  :api="apiInstance"
                />
                <div v-else-if="loading" class="text-center py-12">
                  <p class="text-gray-500">Loading entity details...</p>
                </div>
                <div v-else class="text-center py-12">
                  <p class="text-gray-500">No entity details available.</p>
                </div>
        </div>
        <div v-else-if="vtask && vtask.applicationType==='REGISTRATION_STATUS_CHANGE'" class="p-4 bg-gray-50 rounded border border-gray-200 mb-4 mx-4">
          <label class="text-lg font-bold text-gray-800 block mb-2">Registration Status Change</label>
          <div class="my-2 text-sm font-semibold">ERN : <span class="text-blue">{{ vtask.ern }}</span></div>
          <div v-if="vtask.updateStatus" class="my-2"> <span class="font-semibold">New Status : </span> <span class="px-2 py-1 rounded" :class="getBadgeClass(vtask.updateStatus)">{{ vtask.updateStatus }}</span></div>
          <button class="bg-blue text-white px-3 py-1.5 rounded-sm text-sm hover:bg-blue-dark transition-colors duration-150" @click="showEntityDetails()"> View Entity Details</button>

          
        </div>
        <div v-else-if="vtask && vtask.applicationType==='FORCED_REGISTRATION'">
          <div class="px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm mb-4 mx-4 flex justify-between items-center">
            <div>
              <span class="text-sm font-semibold text-gray-600 block">FORCED REGISTRATION APPLICATION</span>
              <span class="text-lg font-bold text-gray-800">{{ vtask.name }}</span>
            </div>
            <div class="text-right">
              <span class="text-xs text-gray-500 block">Interim ERN</span>
              <span class="text-sm font-semibold text-blue">{{ vtask.interimErn || 'N/A' }}</span>
            </div>
          </div>
          <FormDataViewer
              v-if="formData"
              :form-data="formData"
              :value-data="vtask.data || []"
          />
        </div>
          
  
        <div v-else>
        <FormDataViewer
            v-if="vtask && formData"
            :form-data="formData"
            :value-data="vtask.data || []"
        />
      </div>
      

    </div>

    <div v-show="activeTab === 'attachments'">


      <div class="attachments-card">

        <b-row>
          <b-col cols="4">
            <table v-if="vtask && vtask.attachments && vtask.attachments.length" class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
              <thead class="text-md">
              <tr class="bg-gray-pale">
                <td colspan="12" class="px-2 py-2 font-bold">Attachments</td>
              </tr>
              <tr class="text-xs">
                <th class="px-2 py-1">#</th>
                <th class="px-2 py-1">File Name</th>
                <th class="px-2 py-1 float-end">Action</th>
              </tr>
              </thead>
              <tbody class="text-xs">
              <tr v-for="(attachment, idx) in vtask.attachments" :key="idx" style="border: solid 1px #dedede;">
                <td class="px-2 py-1">{{idx + 1}}</td>
                <td class="px-2 py-1 text-capitalize">{{attachment.title}}</td>
                <td class="px-2 py-1">
                  <button class="float-end bg-gray rounded text-white hover:bg-gray-dark px-2" @click="viewFile(attachment.fileId)">Show</button>
                </td>
              </tr>
              </tbody>
            </table>



           <div v-else class="text-center py-12 text-gray-500">
          <i class="fa fa-folder-open text-4xl mb-3 text-gray-300"></i>
          <p class="text-gray-600">No attachments available for this application</p>
        </div>
        </b-col>
        <b-col cols="8">
          <div class="bg-white shadow-lg rounded-lg overflow-hidden">
            <iframe
                v-if="fileBytes"
                :src="'data:application/pdf;base64,' + fileBytes + '#toolbar=0&navpanes=0&scrollbar=0'"
                class="w-full h-full border-0 pdf-iframe"
            ></iframe>
          </div>
        </b-col>
        </b-row>
      </div>
    </div>

    <div v-if="activeTab === 'messages' && (!vtask || vtask.applicationType !== 'FORCED_REGISTRATION') &&  applicationType !== 'FORCED_REGISTRATION'">
      <TaskMessages :task-id="vtask && vtask.id ? vtask.id : id" :task-type="applicationType" />
    </div>

    <b-modal ref="entityDetails" title="Entity Details" size="xl" hide-footer>
      <NirEntityViewPage v-if="vtask && vtask.ern" :ern="vtask.ern" :hide-back="true" />
    </b-modal>
  </div>
</template>

<script>
import {api} from "../../../../../../app/services/api.service";
import FormDataViewer from '../components/FormDataViewer.vue';
import TaskMessages from '../components/TaskMessages.vue';
import RegistryFormDataViewer from '../../../registry/nir/RegistryFormDataViewer.vue';
import NirEntityViewPage from '../../../registry/nir/NirEntityViewPage.vue';

export default {
  name: 'TaskView',
  components: { FormDataViewer, TaskMessages, RegistryFormDataViewer, NirEntityViewPage },
  props: {
    id: {
      type: String,
      default: '',
    },
    applicationType: {
      type: String,
      default: 'applications',
    },
    task: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      vtask: null,
      form: null,
      formData: null,
      institutions: [],
      activeTab: 'form',
      showFile: false,
      fileToView: '',
      fileBytes: '',
      entity: null,
      viewerFormData: null,
      viewerValueData: [],
      affiliations: [],
    };
  },
  computed: {
    apiInstance() {
      return api();
    },
    institutionName() {
      if (!this.vtask || !this.vtask.institutionId) return 'N/A';
      const inst = (this.institutions || []).find(function (i) { return i.id === this.vtask.institutionId; }.bind(this));
      return inst ? inst.name : 'N/A';
    },
  },
  watch: {
    task: {
      handler(newTask) {
        if (newTask) {
          try {
            this.vtask = JSON.parse(JSON.stringify(newTask));
          } catch (e) {
            this.vtask = newTask;
          }
          this.generateDynamicFormFields();
          this.loading = false;
        }
      },
      immediate: true,
    },
    id: {
      handler(newId) {
        if (newId) {
          this.fetchTask();
        } else {
          if (!this.task) {
            this.vtask = null;
            this.form = null;
            this.formData = null;
            this.loading = false;
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.fetchInstitutions();
  },
  methods: {
    generateDynamicFormFields() {
      if (!this.vtask) return;
      let data = this.vtask.data;
      while (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          break;
        }
      }
      if (!data || !Array.isArray(data)) return;
      this.vtask.data = data;
      
      const fields = [];
      data.forEach((item, index) => {
        let type = 'text';
        const name = item.fieldName || '';
        
        if (name === 'postal_address') type = 'postal-address';
        else if (name === 'physical_address') type = 'admin-units';
        else if (name === 'nature_of_business') type = 'isic';
        else if (name === 'associates') type = 'associates';
        else if (name === 'representatives') type = 'representatives';
        else if (name === 'beneficial_owners') type = 'beneficial-owners';
        else if (name === 'corporate_associates') type = 'corporate-associates';
        else if (name === 'official_email') {
          // If official_phone or official_telephone is also present in data, skip adding a separate text field for official_email
          // because it will be rendered as part of the official_phone contact field.
          const hasPhone = data.some(d => d.fieldName === 'official_phone' || d.fieldName === 'official_telephone');
          if (hasPhone) return;
          type = 'email';
        }
        else if (name === 'official_telephone' || name === 'official_phone') type = 'contact';
        else if (name.includes('phone') || name.includes('contact') || name.includes('telephone')) type = 'contact';

        const label = name
          .replace(/_/g, ' ')
          .toLowerCase()
          .replace(/\b\w/g, c => c.toUpperCase());

        const fieldDef = {
          id: item.fieldId || name,
          fieldName: name,
          label: label,
          type: type,
          position: index + 1
        };

        if (type === 'associates' || type === 'representatives' || type === 'beneficial-owners' || type === 'corporate-associates') {
          fieldDef.cardinality = 'multiple';
        }

        fields.push({ field: fieldDef });
      });

      this.formData = {
        sections: [{
          id: 'dynamic-section',
          name: 'Application Details',
          description: 'Forced Registration Fields',
          position: 1,
          fields: fields
        }]
      };
    },
    fetchInstitutions() {
      api().get('/nir/api/v1/institutions?page=1&limit=1000')
        .then(function (res) {
          if (res.data && res.data.data && res.data.data.content) {
            this.institutions = res.data.data.content;
          }
        }.bind(this))
        .catch(function () {});
    },
    fetchTask() {
      if (!this.id) {
        this.loading = false;
        return;
      }
      this.loading = true;
      var self = this;
      api().get('/nir/api/v1/'+this.applicationType+'/task?id=' + encodeURIComponent(this.id))
        .then(function (res) {
          if (res.data && res.data.data) {
            self.vtask = res.data.data;
            if (self.vtask.data) {
              let data = self.vtask.data;
              while (typeof data === 'string') {
                try {
                  data = JSON.parse(data);
                } catch (e) {
                  break;
                }
              }
              self.vtask.data = data;
            }
            if (self.vtask.applicationType != 'AFFILIATION') {
              self.fetchForm(self.vtask.formId);
              self.fetchFormFields(self.vtask.formId);
            } else {
              self.fetchEntityDetails(self.vtask.interimErn);
            }
          }
          self.loading = false;
        })
        .catch(function () {
          self.loading = false;
        });
    },
    fetchForm(formId) {
      if (!formId) return;
      api().get('/nir/api/v1/configurations/form?id=' + encodeURIComponent(formId))
        .then(function (res) {
          if (res.data && res.data.data) this.form = res.data.data;
        }.bind(this));
    },
    fetchFormFields(formId) {
      if (!formId) return;
      api().get('/nir/api/v1/configurations/forms/fields?formId=' + encodeURIComponent(formId))
        .then(function (res) {
          if (res.data && res.data.data && res.data.data.data) {
            this.formData = res.data.data.data;
          }
        }.bind(this));
    },
    fetchEntityDetails(ern) {
      if (!ern) return;
      var self = this;
      api().get('/nir/api/v1/registry/file?ern=' + encodeURIComponent(ern))
        .then(function (res) {
          if (res.data && res.data.data) {
            self.entity = res.data.data;
            if (res.data.data.entries) {
              var entries = res.data.data.entries;
              var fields = [];
              var valueItems = [];
              self.affiliations = res.data.data.affiliations || [];

              entries.forEach(function (entry, index) {
                var type = 'text';
                if (entry.fieldName === 'postal_address') type = 'postal-address';
                else if (entry.fieldName === 'physical_address') type = 'admin-units';
                else if (entry.fieldName === 'nature_of_business') type = 'isic';
                else if (entry.fieldName === 'associates') type = 'associates';
                else if (entry.fieldName === 'representatives') type = 'representatives';
                else if (entry.fieldName === 'beneficial_owners') type = 'beneficial-owners';
                else if (entry.fieldName === 'official_email') type = 'email';
                else if (entry.fieldName === 'official_telephone') type = 'contact';
                else if (entry.fieldName.includes('contact')) type = 'contact';

                var fieldDef = {
                  id: entry.fieldName,
                  label: entry.label,
                  type: type,
                  position: index + 1
                };
                if (type === 'individuals' || type === 'associates' || type === 'representatives' || type === 'beneficial-owners') {
                  fieldDef.cardinality = 'multiple';
                }
                fields.push({ field: fieldDef });

                var parsedValue = entry.value;
                if (parsedValue) {
                  try {
                    parsedValue = JSON.parse(parsedValue);
                  } catch (e) {
                    console.log(e);
                  }
                }

                valueItems.push({
                  fieldId: entry.fieldName,
                  fieldName: entry.fieldName,
                  value: parsedValue
                });
              });

              self.viewerFormData = {
                sections: [{
                  id: 'entity-details-section',
                  name: 'Registry Information',
                  description: 'Details retrieved from the registry',
                  position: 1,
                  fields: fields
                }]
              };

              self.viewerValueData = [{ data: valueItems }];
            }
          }
        });
    },
    formatDate(dateStr) {
      if (!dateStr) return '—';
      return new Date(dateStr).toLocaleString();
    },

    viewFile(fileId) {
      var self = this;
      this.showFile = true;
      this.fileToView = fileId;
      api().post('/nir/api/v1/applications/attachment', { fileId: fileId })
          .then(function (res) {
            if (res.data && res.data.data && res.data.data.data) {
              self.fileBytes = res.data.data.data;
            }
          });
    },
    showEntityDetails() {
      if (this.$refs.entityDetails) {
        this.$refs.entityDetails.show();
      }},
      getBadgeClass(status) {
      const statusMap = {
        'APPROVED': 'bg-green-100 text-green-700',
        'REJECTED': 'bg-red-100 text-red-700',
        'PENDING': 'bg-yellow-100 text-yellow-700',
        'IN_REVIEW': 'bg-blue-100 text-blue-700'
      };
      return statusMap[status.toUpperCase()] || 'bg-gray-100 text-gray-700';
    }
    
  },
};
</script>

<style scoped>
.details-card { background: white; border-radius: 0.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1); padding: 1.5rem; margin-bottom: 1rem; }
.tab-label { padding: 0.75rem 1.5rem; font-size: 0.875rem; font-weight: 500; border-bottom: 2px solid transparent; cursor: pointer; }
.tab-active { border-color: #157EC2; color: #157EC2; }
.tab-inactive { color: #6b7280; }
.tab-inactive:hover { color: #374151; border-color: #d1d5db; }

.pdf-iframe {
  width: 100%;
  height: 800px;
  overflow-x: auto;
  border:1px solid #b1b1b1;
  top: 0 !important;
}

.badge-count { background: #157EC2; color: #1e40af; font-size: 0.75rem; font-weight: 500; padding: 0.125rem 0.5rem; border-radius: 9999px; }
.attachments-card { background: white; border-radius: 0.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1); padding: 1.5rem; }

@media (min-width: 768px) { .md-col-span-2 { grid-column: span 2; } }
</style>
